export const KF_ICONS = {
  ACCOUNT_BACKUP: "account-backup",
  ACCOUNT_BACKUP_1: "account-backup-1",
  ADD_FOLDER: "add-folder",
  ADD_TO_GO: "add-to-go",
  ADD_USERS: "add-users",
  ADMIN: "admin",
  ADMIN_ASSIGNMENT: "admin-assignment",
  AI: "ai",
  ALIGN_CENTER: "align-center",
  ALIGN_END: "align-end",
  ALIGN_SPACE_AROUND: "align-space-around",
  ALIGN_SPACE_BETWEEN: "align-space-between",
  ALIGN_START: "align-start",
  ALIGN_STRETCH: "align-stretch",
  ALL_FIELDS: "all-fields",
  ALL_ITEMS: "all-items",
  ALL_ITEMS_2: "all-items-2",
  ANALYTICS: "analytics",
  AND: "and",
  APPEARANCE: "appearance",
  APPLY: "apply",
  APPS: "apps",
  APP_STORE: "app-store",
  APP_STORE_BUILDER: "app-store-builder",
  ARCHIVE: "archive",
  ARRAY: "array",
  ARROW_DOWN: "arrow-down",
  ARROW_DOWN_FILLED: "arrow-down-filled",
  ARROW_DOWN_FILLED_1: "arrow-down-filled-1",
  ARROW_DOWN_ROUND: "arrow-down-round",
  ARROW_DOWN_SIMPLE: "arrow-down-simple",
  ARROW_DOWN_SIMPLE_MINIMIZED: "arrow-down-simple-minimized",
  ARROW_DOWN_WITH_BOTTOM_LINE: "arrow-down-with-bottom-line",
  ARROW_LEFT: "arrow-left",
  ARROW_LEFT_FILLED_1: "arrow-left-filled-1",
  ARROW_LEFT_ROUND: "arrow-left-round",
  ARROW_LEFT_SIMPLE: "arrow-left-simple",
  ARROW_LEFT_WITH_LINE: "arrow-left-with-line",
  ARROW_RIGHT: "arrow-right",
  ARROW_RIGHT_FILLED_1: "arrow-right-filled-1",
  ARROW_RIGHT_ROUND: "arrow-right-round",
  ARROW_RIGHT_SIMPLE: "arrow-right-simple",
  ARROW_RIGHT_WITH_LINE: "arrow-right-with-line",
  ARROW_TOP_LEFT: "arrow-top-left",
  ARROW_UP: "arrow-up",
  ARROW_UP_FILLED: "arrow-up-filled",
  ARROW_UP_FILLED_1: "arrow-up-filled-1",
  ARROW_UP_ROUND: "arrow-up-round",
  ARROW_UP_SIMPLE: "arrow-up-simple",
  ARROW_UP_SIMPLE_MINIMIZED: "arrow-up-simple-minimized",
  ARROW_UP_WITH_TOP_LINE: "arrow-up-with-top-line",
  ASCENDING: "ascending",
  ASCENDING_NUMBERS: "ascending-numbers",
  AT: "at",
  ATTACH: "attach",
  AUDIT_LOGS: "audit-logs",
  AUTHENTICATION: "authentication",
  BACKWARD: "backward",
  BACK_OFFICE: "back-office",
  BACK_OFFICE_2: "back-office-2",
  BILLING: "billing",
  BLOCK: "block",
  BLOCK_1: "block-1",
  BOARD: "board",
  BOLD: "bold",
  BOOLEAN: "boolean",
  BORDER_RADIUS_BOTTOM_LEFT: "border-radius-bottom-left",
  BORDER_RADIUS_BOTTOM_RIGHT: "border-radius-bottom-right",
  BORDER_RADIUS_TOP_LEFT: "border-radius-top-left",
  BORDER_RADIUS_TOP_RIGHT: "border-radius-top-right",
  BOT: "bot",
  BRACKET: "bracket",
  BRACKET_EMPTY: "bracket-empty",
  BREAK_DOWN: "break-down",
  BRUSH: "brush",
  BUG: "bug",
  CALENDAR: "calendar",
  CALL: "call",
  CAMERA: "camera",
  CAMERA_OFF: "camera-off",
  CARD: "card",
  CARD_BLOCKER: "card-blocker",
  CELL_PADDING: "cell-padding",
  CELL_SPACING: "cell-spacing",
  CHART: "chart",
  CHART_2: "chart-2",
  CHAT: "chat",
  CHAT_1: "chat-1",
  CHAT_2: "chat-2",
  CHAT_THREAD: "chat-thread",
  CHAT_WITH_PLUS: "chat-with-plus",
  CHAT_WITH_TICK: "chat-with-tick",
  CHECKBOX: "checkbox",
  CHECKLIST: "checklist",
  CHECKMARK: "checkmark",
  CHECK_LIST_2: "check-list-2",
  CHECK_MARK_CIRCLE: "check-mark-circle",
  CLIPBOARD: "clipboard",
  CLOCK: "clock",
  CLOCK_DOTTED: "clock-dotted",
  CLOSE: "close",
  CLOSE_ROUND: "close-round",
  CLOUD_BACKUP: "cloud-backup",
  CLOUD_DOWNLOAD: "cloud-download",
  CLOUD_SYNC: "cloud-sync",
  CODE_1: "code-1",
  CODE_2: "code-2",
  COLLAPSE: "collapse",
  COLLAPSE_ALL: "collapse-all",
  COLLAPSE_ARROW: "collapse-arrow",
  COLLAPSE_VERTICAL: "collapse-vertical",
  COLLAPSE_WITH_BOX: "collapse-with-box",
  COLOR: "color",
  COLOR_AI: "color-ai",
  COLOR_ANALYTICS: "color-analytics",
  COLOR_ANDRIOD: "color-andriod",
  COLOR_APPLE: "color-apple",
  COLOR_APPS: "color-apps",
  COLOR_ASSIST: "color-assist",
  COLOR_AUDIO: "color-audio",
  COLOR_AWS: "color-aws",
  COLOR_BOARDS: "color-boards",
  COLOR_BOX: "color-box",
  COLOR_BRUSH: "color-brush",
  COLOR_CHART: "color-chart",
  COLOR_CHAT: "color-chat",
  COLOR_CHROME: "color-chrome",
  COLOR_CLOSED: "color-closed",
  COLOR_CRITICAL: "color-critical",
  COLOR_CSV: "color-csv",
  COLOR_DATAFORM: "color-dataform",
  COLOR_DATASET: "color-dataset",
  COLOR_DATA_SHEET: "color-data-sheet",
  COLOR_DATA_TABLE: "color-data-table",
  COLOR_DECISION_TABLE: "color-decision-table",
  COLOR_DOCS: "color-docs",
  COLOR_DONE: "color-done",
  COLOR_DRIVE: "color-drive",
  COLOR_DROPBOX: "color-dropbox",
  COLOR_EDGE: "color-edge",
  COLOR_EXCEL: "color-excel",
  COLOR_FACEBOOK: "color-facebook",
  COLOR_FIREFOX: "color-firefox",
  COLOR_FLOW_ICON: "color-flow-icon",
  COLOR_FOLDER: "color-folder",
  COLOR_FROM_LOCAL_COMPUTER: "color-from-local-computer",
  COLOR_GALLERY: "color-gallery",
  COLOR_GCS: "color-gcs",
  COLOR_GOOGLE: "color-google",
  COLOR_GOOGLE_CHAT: "color-google-chat",
  COLOR_GOVERNANCE_AI: "color-governance-ai",
  COLOR_GZIP: "color-gzip",
  COLOR_HIGH: "color-high",
  COLOR_ICON_LIBRARY: "color-icon-library",
  COLOR_INTEGRATION: "color-integration",
  COLOR_INTERNET_EXPLORER: "color-internet-explorer",
  COLOR_IN_PROGRESS: "color-in-progress",
  COLOR_JS: "color-js",
  COLOR_JSON: "color-json",
  COLOR_KANBAN: "color-kanban",
  COLOR_KEY: "color-key",
  COLOR_KISSFLOW_LOGO: "color-kissflow-logo",
  COLOR_LINKED_IN: "color-linkedin",
  COLOR_LIST: "color-list",
  COLOR_LOW: "color-low",
  COLOR_MAGIC_WAND: "color-magic-wand",
  COLOR_MAIL: "color-mail",
  COLOR_MATRIX: "color-matrix",
  COLOR_MEDIUM: "color-medium",
  COLOR_MICROSOFT: "color-microsoft",
  COLOR_NOT_STARTED: "color-not-started",
  COLOR_OFFICE_365: "color-office-365",
  COLOR_ONE_DRIVE: "color-one-drive",
  COLOR_OPERA: "color-opera",
  COLOR_PALATTE: "color-palatte",
  COLOR_PALATTE_2: "color-palatte-2",
  COLOR_PDF: "color-pdf",
  COLOR_PIVOT: "color-pivot",
  COLOR_PORTAL: "color-portal",
  COLOR_PPT: "color-ppt",
  COLOR_PROCESS: "color-process",
  COLOR_PYTHON: "color-python",
  COLOR_REOPENED: "color-reopened",
  COLOR_RESOURCE_LIBRARY: "color-resource-library",
  COLOR_SAFARI: "color-safari",
  COLOR_SCIM: "color-scim",
  COLOR_SLACK: "color-slack",
  COLOR_SPACE: "color-space",
  COLOR_SVG: "color-svg",
  COLOR_TABULAR: "color-tabular",
  COLOR_TEAMS: "color-teams",
  COLOR_TEXT: "color-text",
  COLOR_TIMELINE: "color-timeline",
  COLOR_TWITTER: "color-twitter",
  COLOR_UNKNOWN: "color-unknown",
  COLOR_URL: "color-url",
  COLOR_USER_DELETE: "color-user-delete",
  COLOR_USER_GEAR: "color-user-gear",
  COLOR_VIDEO: "color-video",
  COLOR_WINDOWS: "color-windows",
  COLOR_ZIP: "color-zip",
  COLOR_ZIP_BLUE: "color-zip-blue",
  COLUMN: "column",
  COMPLETED: "completed",
  COMPONENT: "component",
  COMPONENT_TREE: "component-tree",
  CONDITIONAL_PATH: "conditional-path",
  CONNECT: "connect",
  CONNECTOR_2: "connector-2",
  CONVERT_TO_MAIN_ITEM: "convert-to-main-item",
  CONVERT_TO_SUBITEMS: "convert-to-subitems",
  CONVERT_TO_SUBTASK: "convert-to-subtask",
  COPY: "copy",
  CORNERS_1: "corners-1",
  CORNERS_2: "corners-2",
  CRITERION_TYPE: "criterion-type",
  CROP: "crop",
  CROP_ROTATE: "crop-rotate",
  CURRENT_LOCATION: "current-location",
  CUSTOM_LOCATION: "custom-location",
  DARK: "dark",
  DATABASE: "database",
  DATAFORM: "dataform",
  DATASET: "dataset",
  DATA_MODEL_VIEWER: "data-model-viewer",
  DATA_SHEET: "data-sheet",
  DEBUG: "debug",
  DECISION_TABLE: "decision-table",
  DECREASE_INDENT: "decrease-indent",
  DEFAULT_SETTINGS: "default-settings",
  DELEGATE: "delegate",
  DELETE_COLUMN: "delete-column",
  DELETE_ROW: "delete-row",
  DEPLOY: "deploy",
  DEPLOY_2: "deploy-2",
  DESCENDING: "descending",
  DESCENDING_NUMBERS: "descending-numbers",
  DESKTOP: "desktop",
  DEVICES: "devices",
  DIVIDER: "divider",
  DIVISION: "division",
  DOCUMENT_WITH_MAGNIFIER: "document-with-magnifier",
  DOLLAR: "dollar",
  DOT_1: "dot-1",
  DOT_2: "dot-2",
  DOWNLOAD: "download",
  DRAFT: "draft",
  DRAG: "drag",
  DRAG_AND_DROP: "drag-and-drop",
  DT_2_COLUMNS: "dt-2-columns",
  DT_3_COLUMNS: "dt-3-columns",
  DT_4_COLUMNS: "dt-4-columns",
  DT_BUTTON: "dt-button",
  DT_CARD: "dt-card",
  DT_CARD_REPORT: "dt-card-report",
  DT_CHART: "dt-chart",
  DT_CONTAINER: "dt-container",
  DT_CUSTOM_COMPONENT: "dt-custom-component",
  DT_DECISION_TABLE: "dt-decision-table",
  DT_FORM: "dt-form",
  DT_GALLERY_VIEW: "dt-gallery-view",
  DT_HYPERLINK: "dt-hyperlink",
  DT_ICON: "dt-icon",
  DT_IFRAME: "dt-iframe",
  DT_IMAGE: "dt-image",
  DT_KANBAN_VIEW: "dt-kanban-view",
  DT_LABEL: "dt-label",
  DT_LIST_VIEW: "dt-list-view",
  DT_MASTER_DETAILS: "dt-master-details",
  DT_MATRIX_VIEW: "dt-matrix-view",
  DT_METRICS: "dt-metrics",
  DT_PIVOT_REPORT: "dt-pivot-report",
  DT_POPUP: "dt-popup",
  DT_PROGRESS_BAR: "dt-progress-bar",
  DT_REPORTS_100_STACKED_HORIZONTAL_BAR_CHART:
    "dt-reports-100-stacked-horizontal-bar-chart",
  DT_REPORTS_100_STACKED_VERTICAL_BAR_CHART:
    "dt-reports-100-stacked-vertical-bar-chart",
  DT_REPORTS_AREA_CHART: "dt-reports-area-chart",
  DT_REPORTS_AUTO: "dt-reports-auto",
  DT_REPORTS_COMBO_CHART: "dt-reports-combo-chart",
  DT_REPORTS_DONUT_CHART: "dt-reports-donut-chart",
  DT_REPORTS_HORIZONTAL_BAR_CHART: "dt-reports-horizontal-bar-chart",
  DT_REPORTS_LINE_CHART: "dt-reports-line-chart",
  DT_REPORTS_PIE_CHART: "dt-reports-pie-chart",
  DT_REPORTS_SCATTER_CHART: "dt-reports-scatter-chart",
  DT_REPORTS_STACKED_AREA_CHART: "dt-reports-stacked-area-chart",
  DT_REPORTS_VERTICAL_BAR_CHART: "dt-reports-vertical-bar-chart",
  DT_RICHTEXT: "dt-richtext",
  DT_SHEET_VIEW: "dt-sheet-view",
  DT_SMALL_LEFT: "dt-small-left",
  DT_SMALL_LEFT_AND_RIGHT: "dt-small-left-and-right",
  DT_SMALL_RIGHT: "dt-small-right",
  DT_TAB: "dt-tab",
  DT_TABLE_REPORT: "dt-table-report",
  DT_TABLE_VIEW: "dt-table-view",
  DT_TIMELINE_VIEW: "dt-timeline-view",
  DUPLICATE: "duplicate",
  EDIT_1: "edit-1",
  EDIT_2: "edit-2",
  EDIT_EXPLORER: "edit-explorer",
  EDIT_PROCESS: "edit-process",
  EDIT_SETTING: "edit-setting",
  EDIT_WITH_LINE: "edit-with-line",
  EMOJI: "emoji",
  EMOJI_ADD: "emoji-add",
  END: "end",
  EQUAL_TO: "equal-to",
  ERASER: "eraser",
  EVALUATE: "evaluate",
  EXECUTES_ALL_SATISFIED_CONDITIONS: "executes-all-satisfied-conditions",
  EXECUTES_FIRST_SATISFIED_CONDITIONS: "executes-first-satisfied-conditions",
  EXIT_FULL_SCREEN: "exit-full-screen",
  EXPAND: "expand",
  EXPAND_ALL: "expand-all",
  EXPAND_ARROW: "expand-arrow",
  EXPAND_VERTICAL: "expand-vertical",
  EXPAND_WITH_BOX: "expand-with-box",
  EXPONENT: "exponent",
  EXPORT: "export",
  EXTERNAL_DATA: "external-data",
  EXTERNAL_DATA_CONNECTION: "external-data-connection",
  EXTERNAL_DATA_OBJECT: "external-data-object",
  EXTERNAL_LINK: "external-link",
  EYE: "eye",
  FILES: "files",
  FILTER: "filter",
  FILTER_2: "filter-2",
  FILTER_NOTIFY: "filter-notify",
  FIXED_COLUMN_WIDTH: "fixed-column-width",
  FLAG: "flag",
  FLEX: "flex",
  FLOW_SETTING: "flow-setting",
  FOLDER: "folder",
  FOLDER_OPEN: "folder-open",
  FORM: "form",
  FORMULA: "formula",
  FORMULA_2: "formula-2",
  FORM_FIELD_AGGREGATION: "form-field-aggregation",
  FORM_FIELD_CHECKLIST: "form-field-checklist",
  FORM_FIELD_CURRENCY: "form-field-currency",
  FORM_FIELD_DATE: "form-field-date",
  FORM_FIELD_DATE_TIME: "form-field-date-time",
  FORM_FIELD_DROPDOWN: "form-field-dropdown",
  FORM_FIELD_MULTISELECT_DROPDOWN: "form-field-multiselect-dropdown",
  FORM_FIELD_NUMBER: "form-field-number",
  FORM_FIELD_REMOTE_LOOKUP: "form-field-remote-lookup",
  FORM_FIELD_RICHTEXT: "form-field-richtext",
  FORM_FIELD_SEQUENCE_NUMBER: "form-field-sequence-number",
  FORM_FIELD_SIGNATURE: "form-field-signature",
  FORM_FIELD_SINGLE_LINE: "form-field-single-line",
  FORM_FIELD_SLIDER: "form-field-slider",
  FORM_FIELD_SMART_ATTACHMENT: "form-field-smart-attachment",
  FORM_FIELD_SMART_ATTACHMENT_1: "form-field-smart-attachment-1",
  FORM_FIELD_TEXT_AREA: "form-field-text-area",
  FORM_FIELD_USER: "form-field-user",
  FORWARD: "forward",
  FULL_SCREEN: "full-screen",
  GALLERY: "gallery",
  GIF: "gif",
  GLOBE: "globe",
  GOVERNANCE: "governance",
  GO_TO: "go-to",
  GO_TO_MESSAGE: "go-to-message",
  GREATER_THAN: "greater-than",
  GREATER_THAN_OR_EQUAL_TO: "greater-than-or-equal-to",
  GRID: "grid",
  GRID_3: "grid-3",
  GRID_LAYOUT: "grid-layout",
  HAND_SETTINGS: "hand-settings",
  HASHTAG: "hashtag",
  HEART: "heart",
  HEART_SLASH: "heart-slash",
  HELP: "help",
  HIDE: "hide",
  HIGHLIGHT: "highlight",
  HIGHLIGHTER_PEN: "highlighter-pen",
  HISTORY: "history",
  HISTORY_2: "history-2",
  HOME: "home",
  HORIZONTAL_BASELINE: "horizontal-baseline",
  HORIZONTAL_CENTER: "horizontal-center",
  HORIZONTAL_CENTER_LINE: "horizontal-center-line",
  HORIZONTAL_CENTRE_ALIGN: "horizontal-centre-align",
  HORIZONTAL_END: "horizontal-end",
  HORIZONTAL_JUSTIFY_BASELINE: "horizontal-justify-baseline",
  HORIZONTAL_JUSTIFY_CENTER: "horizontal-justify-center",
  HORIZONTAL_JUSTIFY_END: "horizontal-justify-end",
  HORIZONTAL_JUSTIFY_START: "horizontal-justify-start",
  HORIZONTAL_JUSTIFY_STRETCH: "horizontal-justify-stretch",
  HORIZONTAL_LEFT_LINE: "horizontal-left-line",
  HORIZONTAL_LINE: "horizontal-line",
  HORIZONTAL_RIGHT_LINE: "horizontal-right-line",
  HORIZONTAL_START: "horizontal-start",
  HORIZONTAL_STRETCH: "horizontal-stretch",
  IMAGE: "image",
  IMAGE_ANNOTATIONS: "image-annotations",
  IMAGE_BROKEN: "image-broken",
  IMPORT: "import",
  INCREASE_INDENT: "increase-indent",
  INFINITY: "infinity",
  INFO: "info",
  INFO_WITH_CIRCLE: "info-with-circle",
  INLINE_BLOCK: "inline-block",
  INNER_ALIGN_BOTTOM: "inner-align-bottom",
  INNER_ALIGN_LEFT: "inner-align-left",
  INNER_ALIGN_RIGHT: "inner-align-right",
  INNER_ALIGN_UP: "inner-align-up",
  INPUT_PARAMETER: "input-parameter",
  INSERT_COLUMN_AFTER: "insert-column-after",
  INSERT_COLUMN_BEFORE: "insert-column-before",
  INSERT_ROW_ABOVE: "insert-row-above",
  INSERT_ROW_BELOW: "insert-row-below",
  INSERT_TABLE_HEADER: "insert-table-header",
  INTEGRATION: "integration",
  INTERFACE: "interface",
  INVENTORY: "inventory",
  INVOICE: "invoice",
  IN_PROGRESS: "in-progress",
  ITALIC: "italic",
  KANBAN: "kanban",
  KANBAN_2: "kanban-2",
  KANBAN_FILLED: "kanban-filled",
  KEY: "key",
  KEYBOARD: "keyboard",
  KF_ASSIST: "kf-assist",
  LAPTOP: "laptop",
  LAYOUT: "layout",
  LEFT_ARROW_SQUASHED: "left-arrow-squashed",
  LEFT_CLOSE: "left-close",
  LESS_THAN: "less-than",
  LESS_THAN_OR_EQUAL_TO: "less-than-or-equal-to",
  LIGHT: "light",
  LIGHTNING: "lightning",
  LINE_HEIGHT: "line-height",
  LINK: "link",
  LIST: "list",
  LIST_1: "list-1",
  LIST_SORT_DOWN: "list-sort-down",
  LIST_SORT_UP: "list-sort-up",
  LIST_WITH_DOTS: "list-with-dots",
  LIST_WITH_NUMBERS: "list-with-numbers",
  LOCATION: "location",
  LOCK: "lock",
  LOCK_MINIMISED: "lock-minimised",
  LOCK_OPENED: "lock-opened",
  LOGIC: "logic",
  LOGOUT: "logout",
  MAGIC_WAND: "magic-wand",
  MAIL: "mail",
  MARGIN_BOTTOM: "margin-bottom",
  MARGIN_LEFT: "margin-left",
  MARGIN_RIGHT: "margin-right",
  MARGIN_UP: "margin-up",
  MENU: "menu",
  MERGE_CELLS: "merge-cells",
  MIC: "mic",
  MIC_MUTE: "mic-mute",
  MINUS: "minus",
  MINUS_WITH_ROUNDED: "minus-with-rounded",
  MIRROR_HORIZONTAL: "mirror-horizontal",
  MIRROR_VERTICAL: "mirror-vertical",
  MOBILE: "mobile",
  MOBILE_ROTATE: "mobile-rotate",
  MONITOR: "monitor",
  MORE_HORIZONTAL: "more-horizontal",
  MORE_HORIZONTAL_ROUNDED: "more-horizontal-rounded",
  MORE_VERTICAL: "more-vertical",
  MOVE_FOLDER: "move-folder",
  MOVE_STEP: "move-step",
  MOVE_TO_OTHER_ITEM: "move-to-other-item",
  MULTIPLY: "multiply",
  MULTI_LANGUAGE: "multi-language",
  MY_ITEM: "my-item",
  MY_TASK: "my-task",
  NAVIGATION: "navigation",
  NAVIGATION_ARROW: "navigation-arrow",
  NETWORK: "network",
  NETWORK_OFF: "network-off",
  NEW_STEP: "new-step",
  NOTES: "notes",
  NOTE_TICK: "note-tick",
  NOTIFICATION: "notification",
  NOTIFICATIONS: "notifications",
  NOTIFICATION_SETTING: "notification-setting",
  NOTIFICATION_SETTINGS: "notification-settings",
  NOTIFICATION_TURN_OFF: "notification-turn-off",
  NOTIFICATION_WITH_TICK: "notification-with-tick",
  NOT_EQUAL_TO: "not-equal-to",
  NO_CONDITION_MATCHES: "no-condition-matches",
  OBJECT: "object",
  OFFICE: "office",
  OPEN_AI: "open-ai",
  OR: "or",
  OUTER_ALIGN_BOTTOM: "outer-align-bottom",
  OUTER_ALIGN_LEFT: "outer-align-left",
  OUTER_ALIGN_RIGHT: "outer-align-right",
  OUTER_ALIGN_UP: "outer-align-up",
  PADDING: "padding",
  PAGE: "page",
  PAGES: "pages",
  PAGE_BORDER_DASH: "page-border-dash",
  PAGE_BORDER_THICKNESS: "page-border-thickness",
  PAGE_BREAK: "page-break",
  PAINT: "paint",
  PAPERCLIP: "paperclip",
  PARALLEL_BRANCH: "parallel-branch",
  PAUSE: "pause",
  PICTURE_IN_PICTURE: "picture-in-picture",
  PICTURE_IN_PICTURE_RELEASE: "picture-in-picture-release",
  PIE_CHART: "pie-chart",
  PIN: "pin",
  PIN_LOCATION_CROSS: "pin-location-cross",
  PIN_LOCATION_PLUS: "pin-location-plus",
  PIVOT: "pivot",
  PLAY: "play",
  PLAYBACK_SPEED: "playback-speed",
  PLUG: "plug",
  PLUS: "plus",
  PLUS_2: "plus-2",
  PLUS_3: "plus-3",
  POLL: "poll",
  PORTAL: "portal",
  POSITION_BOTTOM: "position-bottom",
  POSITION_LEFT: "position-left",
  POSITION_RIGHT: "position-right",
  POSITION_UP: "position-up",
  PRINT: "print",
  PROCESS: "process",
  PURCHASE_ORDER: "purchase-order",
  PURCHASE_ORDER_2: "purchase-order-2",
  PURCHASE_REQUEST: "purchase-request",
  QUOTE: "quote",
  QUOTES: "quotes",
  RADIO_BUTTON: "radio-button",
  RECEIPT: "receipt",
  RECEIPT_2: "receipt-2",
  REDO: "redo",
  REFRESH: "refresh",
  REJECT: "reject",
  REMINDER: "reminder",
  REMOVE_TABLE_BORDER: "remove-table-border",
  REPLY: "reply",
  REPORTS: "reports",
  REPORTS_1: "reports-1",
  REPORT_ANALYTICS: "report-analytics",
  REQUIRED: "required",
  RESET: "reset",
  RESOURCE_MANAGER: "resource-manager",
  RICHTEXT: "richtext",
  RICHTEXT_2: "richtext-2",
  RIGHT_EXPAND: "right-expand",
  ROTATE: "rotate",
  ROTATE_LEFT_IMAGE: "rotate-left-image",
  ROTATE_RIGHT_IMAGE: "rotate-right-image",
  ROW: "row",
  SAVE: "save",
  SCANNER: "scanner",
  SCREEN_WITH_LOCK: "screen-with-lock",
  SEARCH: "search",
  SECURITY_KEY_2: "security-key-2",
  SECURITY_KEY_DIAGONAL: "security-key-diagonal",
  SECURITY_SHIELD: "security-shield",
  SELECT_ROUND: "select-round",
  SEND: "send",
  SEND_BACK: "send-back",
  SERVICE_ACCOUNT: "service-account",
  SETTINGS: "settings",
  SHAPES: "shapes",
  SHARE: "share",
  SHARED_DRIVE: "shared-drive",
  SHARE_2: "share-2",
  SHIELD: "shield",
  SHIPPING_NOTICE: "shipping-notice",
  SHUFFLE: "shuffle",
  SINGLE_PATH: "single-path",
  SMALL_CAPS: "small-caps",
  SORT: "sort",
  SORT_NOTIFY: "sort-notify",
  SOURCING: "sourcing",
  SPACE: "space",
  SPLIT_CELLS: "split-cells",
  SPLIT_SCREEN: "split-screen",
  STAR: "star",
  STATUS: "status",
  STEP_METRICS: "step-metrics",
  STOP_WATCHING: "stop-watching",
  STRING: "string",
  SUBSCRIPT: "subscript",
  SUBTASK: "subtask",
  SUB_FLOW: "sub-flow",
  SUPERSCRIPT: "superscript",
  SWAP: "swap",
  SWAP_TOP_DOWN: "swap-top-down",
  SWITCH_OFF: "switch-off",
  SWITCH_ON: "switch-on",
  SYNC: "sync",
  TABLE: "table",
  TABULAR_REPORTS: "tabular-reports",
  TEXT_1: "text-1",
  TEXT_2: "text-2",
  TEXT_ALIGN_CENTER: "text-align-center",
  TEXT_ALIGN_LEFT: "text-align-left",
  TEXT_ALIGN_PARAGRAPH: "text-align-paragraph",
  TEXT_ALIGN_RIGHT: "text-align-right",
  TEXT_COLOR: "text-color",
  TEXT_STRIKETHROUGH: "text-strikethrough",
  TEXT_STYLE: "text-style",
  TEXT_TYPE: "text-type",
  THUMBS_DOWN: "thumbs-down",
  THUMBS_UP: "thumbs-up",
  TIMELINE: "timeline",
  TOOLS: "tools",
  TOOLS_CLEAR_FORMAT: "tools-clear-format",
  TOOLS_H_1: "tools-h-1",
  TOOLS_H_2: "tools-h-2",
  TOOLS_LINK: "tools-link",
  TRANSPARENCY: "transparency",
  TRASH: "trash",
  TRUE_OR_FALSE: "true-or-false",
  UNDERLINE: "underline",
  UNDO: "undo",
  UNLINK: "unlink",
  UNPIN: "unpin",
  UPLOAD: "upload",
  UP_ARROW: "up-arrow",
  USER: "user",
  USER_BATCH: "user-batch",
  USER_DELETE: "user-delete",
  USER_EDIT: "user-edit",
  USER_GROUP: "user-group",
  USER_GROUP_2: "user-group-2",
  USER_GROUP_3: "user-group-3",
  USER_INFO: "user-info",
  USER_MY_ITEMS: "user-my-items",
  USER_PERFORMANCE: "user-performance",
  USER_PRIVACY: "user-privacy",
  USER_QUESTION: "user-question",
  USER_ROLE: "user-role",
  USER_SETTINGS: "user-settings",
  VARIABLES: "variables",
  VERSION_HISTORY: "version-history",
  VERTICAL_BASELINE: "vertical-baseline",
  VERTICAL_BOTTOM_LINE: "vertical-bottom-line",
  VERTICAL_CENTER: "vertical-center",
  VERTICAL_CENTER_LINE: "vertical-center-line",
  VERTICAL_CENTRE_ALIGN: "vertical-centre-align",
  VERTICAL_END: "vertical-end",
  VERTICAL_JUSTIFY_CENTER: "vertical-justify-center",
  VERTICAL_JUSTIFY_END: "vertical-justify-end",
  VERTICAL_JUSTIFY_SPACE_AROUND: "vertical-justify-space-around",
  VERTICAL_JUSTIFY_SPACE_BETWEEN: "vertical-justify-space-between",
  VERTICAL_JUSTIFY_START: "vertical-justify-start",
  VERTICAL_START: "vertical-start",
  VERTICAL_STRETCH: "vertical-stretch",
  VERTICAL_TOP_LINE: "vertical-top-line",
  VERTICAL_WRAP_CENTER: "vertical-wrap-center",
  VERTICAL_WRAP_END: "vertical-wrap-end",
  VERTICAL_WRAP_SPACE_AROUND: "vertical-wrap-space-around",
  VERTICAL_WRAP_SPACE_BETWEEN: "vertical-wrap-space-between",
  VERTICAL_WRAP_START: "vertical-wrap-start",
  VERTICAL_WRAP_STRETCH: "vertical-wrap-stretch",
  VIDEO: "video",
  VISIBILITY: "visibility",
  VOLUME: "volume",
  VOLUME_MUTE: "volume-mute",
  WALLET: "wallet",
  WARNING: "warning",
  WARNING_2: "warning-2",
  WATCH: "watch",
  WIDGET: "widget",
  WIDGET_2: "widget-2",
  WIDGET_TREE: "widget-tree",
  WITHDRAWN: "withdrawn",
  ZOOM_IN: "zoom-in",
  ZOOM_OUT: "zoom-out"
};
export const KF_OTHER_ICONS = {
  ACCESSKEY: "accesskey",
  ACTIVESESSIONS: "activesessions",
  ADMINS: "admins",
  AMERICAN_EXPRESS: "american-express",
  ANDROIDMOBILE: "androidmobile",
  ANDROID_IPAD: "android-ipad",
  APIKEY: "apikey",
  ATTACHMENT: "attachment",
  BOARDS: "boards",
  CHROMEBOOK: "chromebook",
  COMPUTER: "computer",
  CONNECTIONS: "connections",
  CREATORS: "creators",
  CREDIT_CARD: "creditcard",
  DARK_MODE: "dark-mode",
  DATASET: "dataset",
  DATASETNOTREFERRED: "datasetnotreferred",
  DEBUG: "debug",
  DEFAULT_EMPTY_STATE: "default-empty-state",
  DEFAULT_IPAD: "default-ipad",
  DEFAULT_USER_PROFILE: "default-user-profile",
  DIM: "dim",
  DINERS_CLUB_LOGO: "diners-club-logo",
  DISCOVER_CARD_LOGO: "discover-card-logo",
  DOWNLOADLOG: "downloadlog",
  EXPORTLOG: "exportlog",
  EXPORT_CSV: "export-csv",
  EXPORT_JSON: "export-json",
  FLOWS: "flows",
  FRAME_427318674: "frame-427318674",
  FRAME_427318688: "frame-427318688",
  FRAME_427318690: "frame-427318690",
  FRAME_427318693: "frame-427318693",
  FRAME_427318695: "frame-427318695",
  FRAME_427318696: "frame-427318696",
  GROUPS: "groups",
  INACTIVEBOARD: "inactiveboard",
  INACTIVEPROCESS: "inactiveprocess",
  INTEGRATIONS: "integrations",
  IPAD: "ipad",
  IPHONE: "iphone",
  JCB_LOGO: "jcb-logo",
  KISSFLOW_LOGO: "kissflow-logo",
  LIGHT: "light",
  LINUX: "linux",
  LIST: "list",
  LOOKEDUPFROM: "lookedupfrom",
  LOOKEDUPTO: "lookedupto",
  MACKBOOK: "mackbook",
  MACOS: "macos",
  MASTERCARD_2019_LOGO: "mastercard-2019-logo",
  MOBILE: "mobile",
  PRINTLOG: "printlog",
  PROCESSES: "processes",
  RU_PAY: "rupay",
  SCIM: "scim",
  SELECT_CIRCLE: "select-circle",
  SERVICE_ACCOUNT_DEFAULT: "service-account-default",
  SIMPLE_CARD_STATE: "simple-card-state",
  USERS: "users",
  USER_INFO_3: "user-info-3",
  VISA_INC_LOGO: "visa-inc-logo",
  WARNING: "warning",
  WINDOWS: "windows"
};
export const KF_ILLUSTRATIONS = {
  ACCOUNT_LOCKED: "account-locked",
  ADD_DATA_TABLE: "add-data-table",
  ALL_CAUGHT_UP: "all-caught-up",
  ARCHIVE: "archive",
  CONFIGURE_REPORT: "configure-report",
  CREATE_REPORT: "create-report",
  CREATE_SERVICE_ACCOUNT: "create-service-account",
  CSV: "csv",
  DUPLICATION_NOT_ALLOWED: "duplication-not-allowed",
  EMPTY_CART: "empty-cart",
  EMPTY_DATASET: "empty-dataset",
  EMPTY_DATA_SOURCE: "empty-data-source",
  EMPTY_DATA_TABLE: "empty-data-table",
  EMPTY_EXPLORER: "empty-explorer",
  EMPTY_FEED: "empty-feed",
  EMPTY_GALLERY: "empty-gallery",
  EMPTY_MY_ITEMS: "empty-my-items",
  EMPTY_NOTES: "empty-notes",
  EMPTY_RESPONSE: "empty-response",
  EMPTY_STATE_1: "empty-state-1",
  EMPTY_WALLET: "empty-wallet",
  FILTER: "filter",
  FORM_NOT_ACCESSIBLE: "form-not-accessible",
  IMPORTED_SUCCESSFULLY: "imported-successfully",
  ITEMS_MOVED_OUT_OF_QUEUE: "items-moved-out-of-queue",
  MAXIMUM_COLUMN_REACHED: "maximum-column-reached",
  MAXIMUM_FIELD_REACHED: "maximum-field-reached",
  MESSAGE_DELIVERED: "message-delivered",
  MY_ITEMS: "my-items",
  NOTHING_FOUND: "nothing-found",
  NO_ACCESS_KEY: "no-access-key",
  NO_ACTIVITIES: "no-activities",
  NO_ATTACHMENTS: "no-attachments",
  NO_DATA_IN_THE_SHEET: "no-data-in-the-sheet",
  NO_DOCUMENTS_AVAILABLE: "no-documents-available",
  NO_EVENTS: "no-events",
  NO_FILE: "no-file",
  NO_FILES_SELECTED: "no-files-selected",
  NO_ITEM_IN_QUEUE: "no-item-in-queue",
  NO_MATCHES_FOUND: "no-matches-found",
  NO_MATCHES_IDENTIFIED: "no-matches-identified",
  NO_MEMBER_FOUND: "no-member-found",
  NO_MESSAGE_FOUND: "no-message-found",
  NO_NOTIFICATION: "no-notification",
  NO_PAYMENT_RECORD: "no-payment-record",
  NO_PENDING_ITEMS: "no-pending-items",
  NO_RELEVANT_DATA: "no-relevant-data",
  NO_RELEVANT_INFORMATION: "no-relevant-information",
  NO_TASK_FOUND: "no-task-found",
  NO_VIDEOS: "no-videos",
  OVERDUE: "overdue",
  SUCCESS: "success",
  THANKS_FOR_SUBMITTING: "thanks-for-submitting",
  TRIAL_END_SOON: "trial-end-soon",
  UNDER_MAINTENANCE: "under-maintenance",
  UNHAPPY_FACE: "unhappy-face"
};
